import axios from 'axios'
import { getBaseURL } from '@/utils/buildBaseURL'

export const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export const viacep = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
})

export const gtag = axios.create({
  baseURL: 'https://www.googletagmanager.com/gtag',
})

api.interceptors.request.use(
  async (config) => {
    config.baseURL = getBaseURL()
    return config
  },
  (error) => Promise.reject(error)
)

export default {
  api,
  viacep,
  gtag,
}
